import React, { useState } from 'react'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import AddIcon from '@mui/icons-material/Add'
import { useShallow } from 'zustand/react/shallow'
import { useCrmSettingsStore } from '../stores/crmSettingsStore'
import { ConfirmDialog } from '../PersonDetailPage/ConfirmDialog'

export const StagesEditor = () => {
    const { stages, addStage, renameStage, deleteStage, moveStage } = useCrmSettingsStore(
        useShallow((s) => ({
            stages: s.stages,
            addStage: s.addStage,
            renameStage: s.renameStage,
            deleteStage: s.deleteStage,
            moveStage: s.moveStage,
        }))
    )
    const [newName, setNewName] = useState('')
    // Index of the stage awaiting delete confirmation.
    const [pendingIndex, setPendingIndex] = useState(null)
    const pending = stages[pendingIndex]
    const [confirmingAdd, setConfirmingAdd] = useState(false)

    // A blank name still just clears the field; a real one asks first.
    const submitNew = () => (newName.trim() ? setConfirmingAdd(true) : setNewName(''))

    const confirmNew = () => {
        addStage(newName)
        setNewName('')
        setConfirmingAdd(false)
    }

    return (
        <div>
            <div className="field-help">
                These are the columns on your pipeline board. Rename inline, reorder with the arrows,
                and remove a stage without losing the deals that passed through it.
            </div>

            <div className="stage-list">
                {stages.map((s, i) => (
                    <div className="stage-row" key={s.id}>
                        <span className="stage-order">{i + 1}</span>
                        <input
                            className="stage-name-input"
                            defaultValue={s.name}
                            onBlur={(e) => { if (e.target.value.trim() && e.target.value !== s.name) renameStage(s.id, e.target.value.trim()) }}
                            onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur() }}
                        />
                        <button className="stage-icon-btn" disabled={i === 0} onClick={() => moveStage(s.id, -1)} title="Move up"><ArrowUpwardIcon style={{ fontSize: 16 }} /></button>
                        <button className="stage-icon-btn" disabled={i === stages.length - 1} onClick={() => moveStage(s.id, 1)} title="Move down"><ArrowDownwardIcon style={{ fontSize: 16 }} /></button>
                        <button className="stage-icon-btn danger" disabled={i === 0} onClick={() => setPendingIndex(i)} title={i === 0 ? "The first stage can't be removed" : 'Remove'}><DeleteOutlineIcon style={{ fontSize: 16 }} /></button>
                    </div>
                ))}
                {stages.length === 0 && <div className="field-help">No stages yet.</div>}
            </div>

            <div className="stage-add">
                <input
                    placeholder="New stage name…"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') submitNew() }}
                />
                <button className="stage-add-btn" onClick={submitNew}><AddIcon style={{ fontSize: 15 }} /> Add stage</button>
            </div>

            {pending && (
                <ConfirmDialog
                    open
                    title={`Delete “${pending.name}” stage?`}
                    message={`Open cards in this stage will be moved to “${stages[pendingIndex - 1].name}”.`}
                    confirmLabel="Delete stage"
                    onCancel={() => setPendingIndex(null)}
                    onConfirm={() => { deleteStage(pending.id); setPendingIndex(null) }}
                />
            )}
            {confirmingAdd && (
                <ConfirmDialog
                    open
                    tone="primary"
                    title={`Add “${newName.trim()}” stage?`}
                    message="This stage will be added to the end of your pipeline."
                    confirmLabel="Add stage"
                    onCancel={() => setConfirmingAdd(false)}
                    onConfirm={confirmNew}
                />
            )}
        </div>
    )
}
